/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Billing from "layouts/billing";
import CustomerList from "./pages/users/CustomerList";
import ShopList from "pages/shops/ShopList";
import AddNewUser from "pages/users/AddNew";
import AddNewShop from "pages/shops/AddNewShop";
import BodyMGuide from "pages/bodymeasurementGuide/BodyMGuide";
import AddNewBmGuide from "pages/bodymeasurementGuide/AddNewBmGuide";
import BodyMShapes from "pages/bodyMeasurementShapes/List";
import AddNewBmShape from "pages/bodyMeasurementShapes/AddNew";
// import ComplaintTypesList from "pages/complaintTypes/ComplaintTList";
// import ComplaintTypeRList from "pages/complaintTypesReasons/List";
// import AddNewComplaintType from "pages/complaintTypes/AddNew";
// import AddCTypeReason from "pages/complaintTypesReasons/AddNew";
import ChatMain from "pages/chatpage/ChatMain";
import CategoryList from "pages/manageCategory/CategoryList";
import MasterProductList from "pages/manageProduct/MasterProductList";
import ProductvariantList from "pages/manageProduct/ProductvariantList";
import UserComplaintList from "pages/usercomplaint/List";
import PageList from "pages/managepages/PageList";
import PriceList from "pages/manageDeliveryPrice/PriceList";
import PriceConvertorList from "pages/priceConvertor/PriceConvertorList";
import AddPriceConvertor from "pages/priceConvertor/AddPriceConvertor"
import AddNewPrice from "pages/manageDeliveryPrice/AddNew";
import AddNewCategory from "pages/manageCategory/AddNew";
import AddNewProduct from "pages/manageProduct/AddNew";
import ContactSetting from "pages/settings/ContactSettings";
// import UserComplaintRequest from "pages/usercomplaintRequests/List";
import OrderList from "pages/orderManagement/OrderList";
// import { IoMdSettings } from "react-icons/io";
import AddProcuctVariant from "pages/manageProduct/AddProductVariant";
import { MdOutlineInsertPageBreak } from "react-icons/md";
import RTL from "layouts/rtl";
import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import { FaUsers } from "react-icons/fa";
import { MdOutlineShoppingCart } from "react-icons/md";
import { FaStore } from "react-icons/fa";
import { IoIosBody } from "react-icons/io";
import Ordertracking from "pages/Orders Tracking/Ordertracking";
import Review from "pages/Review/Review";
import Ignored from "pages/Review/Ignored";
import ReviewsIcon from "@mui/icons-material/Reviews";
import Terms_of_views from "pages/Terms of views/Terms_of_views";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Privacy_Policy from "pages/Privacy Policy/Privacy_Policy";
import PrivacyTipIcon from "@mui/icons-material/PrivacyTip";
import Personal_data from "pages/Personal Data/Personal_data";
import DataUsageIcon from "@mui/icons-material/DataUsage";
import About_us from "pages/About us/About_us";
import InfoIcon from "@mui/icons-material/Info";
import License_and_Agreement from "pages/License and Agreement/License_and_Agreement";
import Corporate_information from "pages/Corporate information/Corporate_information";
import MarkUnreadChatAltIcon from "@mui/icons-material/MarkUnreadChatAlt";
// @mui icons
import Icon from "@mui/material/Icon";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/",
    treeView: false,
    component: <Dashboard />,
  },
  {
    type: "collapse",
    name: "Category",
    key: "category",
    icon: <Icon fontSize="small">category</Icon>,
    route: "/categories",
    treeView: false,
    component: <CategoryList />,
  },
  {
    type: "collapse",
    name: "Orders",
    key: "order",
    icon: <Icon fontSize="small">store</Icon>,
    route: "/orders",
    treeView: false,
    component: <OrderList />,
  },

  {
    type: "collapse",
    name: "Orders/Refund Tracking",
    key: "ordertracking",
    icon: <Icon fontSize="small">store</Icon>,
    route: "/ordertracking",
    treeView: false,
    component: <Ordertracking/>,
  },

  {
    type: "collapse",
    name: "Chats",
    key: "chats",
    icon: <MarkUnreadChatAltIcon style={{ color: "white", fontSize: "large" }} />,
    route: "/chats",
    treeView: false,
    component: <ChatMain/>,
  },

  {
    type: "collapse",
    name: "Review",
    key: "Review",
    icon: <ReviewsIcon style={{ color: "white", fontSize: "large" }}/>,
    route: "/Review",
    treeView: true,
    children: [
      {
        key: 1,
        route: "/Review",
        name: "Review",
        component: <Review/>,
      },
      {
        key: 2,
        route: "/ignored",
        name:"Ignored",
        component: <Ignored />,
      },
    ],
  },

  {
    type: "collapse",
    name: "Manage Users",
    key: "tables",
    icon: <FaUsers style={{ color: "white", fontSize: "large" }} />,
    treeView: true,
    children: [
      {
        key: 1,
        name: "Customer List",
        route: "/customers",
        component: <CustomerList />,
      },
      {
        key: 2,
        route: "/add_new_user",
        name: "Add New",
        component: <AddNewUser />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Manage Shop",
    key: "billing",
    icon: <MdOutlineShoppingCart style={{ color: "white", fontSize: "large" }} />,
    route: "/billing",
    treeView: true,
    children: [
      {
        key: 1,
        route: "/Shops",
        name: "Shop List",
        component: <ShopList />,
      },
      {
        key: 2,
        route: "/add_new_shop",
        name: "Add New",
        component: <AddNewShop />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Body Measurement Guide",
    key: "billing",
    icon: <IoIosBody style={{ color: "white", fontSize: "large" }} />,
    route: "/billing",
    treeView: true,
    children: [
      {
        key: 1,
        route: "/body-measurement-guide",
        name: "List",
        component: <BodyMGuide />,
      },
      {
        key: 2,
        route: "/create-body-measurement",
        name: "Add New",
        component: <AddNewBmGuide />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Body Measurement Shapes",
    key: "billing",
    icon: <IoIosBody style={{ color: "white", fontSize: "large" }} />,
    treeView: true,
    children: [
      {
        key: 1,
        route: "/shapes",
        name: "List",
        component: <BodyMShapes />,
      },
      {
        key: 2,
        route: "/create-shapes",
        name: "Add New",
        component: <AddNewBmShape />,
      },
    ],
  },
  // {
  //   type: "collapse",
  //   name: "Complaint Types",
  //   key: "billing",
  //   icon: <IoIosBody style={{ color: "white", fontSize: "large" }} />,
  //   route: "/billing",
  //   treeView: true,
  //   children: [
  //     {
  //       key: 1,
  //       route: "/complaint-types",
  //       name: "List",
  //       component: <ComplaintTypesList />,
  //     },
  //     {
  //       key: 2,
  //       route: "/add-new-complaint-types",
  //       name: "Add New",
  //       component: <AddNewComplaintType />,
  //     },
  //   ],
  // },
  // {
  //   type: "collapse",
  //   name: "Complain Type Reasons",
  //   key: "billing",
  //   icon: <IoIosBody style={{ color: "white", fontSize: "large" }} />,
  //   route: "/billing",
  //   treeView: true,
  //   children: [
  //     {
  //       key: 1,
  //       route: "/complaint-types-reasons",
  //       name: "List",
  //       component: <ComplaintTypeRList />,
  //     },
  //     {
  //       key: 2,
  //       route: "/category",
  //       name: "Add New",
  //       component: <AddCTypeReason />,
  //     },
  //   ],
  // },
  {
    type: "collapse",
    name: "Manage Product",
    key: "rtl",
    icon: <FaStore style={{ color: "white", fontSize: "large" }} />,
    route: "",
    // component: <RTL />,
    treeView: true,
    children: [
      // {
      //   key: 1,
      //   route: "/categories",
      //   name: "Category",
      //   component: <CategoryList />,
      // },
      {
        key: 2,
        route: "/products-list",
        name: "Product List",
        component: <MasterProductList />,
      },
      // {
      //   key: 3,
      //   route: "/product-varian-t-list",
      //   name: "Products Variant List",
      //   component: <ProductvariantList />,
      // },
      {
        key: 4,
        route: "/new_product",
        name: "Add New",
        component: <AddNewProduct />,
      },
    ],
  },
  // {
  //   type: "collapse",
  //   name: "User Complaint Request",
  //   key: "billing",
  //   icon: <IoIosBody style={{ color: "white", fontSize: "large" }} />,
  //   route: "/billing",
  //   treeView: true,
  //   children: [
  //     {
  //       key: 1,
  //       route: "/user-complaints-requests",
  //       name: "List",
  //       component: <UserComplaintRequest />,
  //     },
  //   ],
  // },
  {
    type: "collapse",
    name: "Manage Pages",
    key: "billing",
    icon: <MdOutlineInsertPageBreak style={{ color: "white", fontSize: "large" }} />,
    route: "/billing",
    treeView: true,
    children: [
      {
        key: 1,
        route: "/pages",
        name: "List",
        component: <PageList />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Manage Delivery Prices",
    key: "billing",
    icon: <MdOutlineInsertPageBreak style={{ color: "white", fontSize: "large" }} />,
    route: "/billing",
    treeView: true,
    children: [
      {
        key: 1,
        route: "/delivery-prices",
        name: "List",
        component: <PriceList />,
      },
      {
        key: 2,
        route: "/add-prices",
        name: "Add New",
        component: <AddNewPrice />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Statics Pages",
    key: "Terms_of_views",
    icon: <VisibilityIcon style={{ color: "white", fontSize: "large" }} />,
    route: "/Terms_of_views",
    treeView: true,
    children: [
      {
        key: 1,
        route: "/Terms_of_views",
        name: "Terms_of_views",
        component: <Terms_of_views />,
      },
      {
        key: 2,
        route: "/Privacy_Policy",
        name: "Privacy_Policy",
        component: <Privacy_Policy />,
      },
      {
        key: 3,
        route: "/Personal_data",
        name: "Personal_data",
        component: <Personal_data />,
      },
      {
        key: 4,
        route: "/About_us",
        name: "About_us",
        component: <About_us />,
      },
      {
        key: 5,
        route: "/License_and_Agreement",
        name: "License_and_Agreement",
        component: <License_and_Agreement />,
      },
      {
        key: 6,
        route: "/Corporate_information",
        name: "Corporate_information",
        component: <Corporate_information />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Price Convertor",
    key: "priceconvertor",
    icon: <MdOutlineInsertPageBreak style={{ color: "white", fontSize: "large" }} />,
    route: "/priceconvertor",
    treeView: true,
    children: [
      {
        key: 1,
        route: "/priceconvertor-List",
        name: "List",
        component: <PriceConvertorList />,
      },
      {
        key: 2,
        route: "/priceconvertor-add",
        name: "Add New",
        component: <AddPriceConvertor />,
      },
    ],
  },

  // {
  //   type: "collapse",
  //   name: "Settings",
  //   key: "settings",
  //   icon: <IoMdSettings style={{ color: "white", fontSize: "large" }} />,
  //   route: "/settings",
  //   treeView: true,
  //   children: [
  //     {
  //       key: 1,
  //       route: "/settings",
  //       name: "Common settings",
  //       component: <ContactSetting />,
  //     },
  //   ],
  // },
];

export default routes;
